export function toQueryDurationBucket(
    queryDurationInSeconds: number
): {
    lowerBoundSeconds: number | null;
    upperBoundSeconds: number | null;
} {
    if (queryDurationInSeconds <= 0) {
        // Should not be possible if query duration calculations are correct
        return { lowerBoundSeconds: null, upperBoundSeconds: 0 };
    } else if (queryDurationInSeconds <= 1) {
        return { lowerBoundSeconds: 0, upperBoundSeconds: 1 };
    } else if (queryDurationInSeconds <= 2) {
        return { lowerBoundSeconds: 1, upperBoundSeconds: 2 };
    } else if (queryDurationInSeconds <= 5) {
        return { lowerBoundSeconds: 2, upperBoundSeconds: 5 };
    } else if (queryDurationInSeconds <= 10) {
        return { lowerBoundSeconds: 5, upperBoundSeconds: 10 };
    } else if (queryDurationInSeconds <= 30) {
        return { lowerBoundSeconds: 10, upperBoundSeconds: 30 };
    } else if (queryDurationInSeconds > 30) {
        return { lowerBoundSeconds: 30, upperBoundSeconds: null };
    } else {
        // handle null scenario
        return { lowerBoundSeconds: null, upperBoundSeconds: null };
    }
}

/**
 * Get duration buckets up to 24 hours.
 *
 * @param duration
 */
export function getExtendedDurationBucket(duration: number): string {
    let bounds = null;

    if (duration <= 0) {
        // Should not be possible if duration calculations are correct
        bounds = { lowerBoundSeconds: null, upperBoundSeconds: 0 };
    } else if (duration <= 5) {
        bounds = { lowerBoundSeconds: 0, upperBoundSeconds: 5 };
    } else if (duration <= 30) {
        bounds = { lowerBoundSeconds: 5, upperBoundSeconds: 60 };
    } else if (duration <= 60) {
        bounds = { lowerBoundSeconds: 60, upperBoundSeconds: 300 };
    } else if (duration <= 300) {
        bounds = { lowerBoundSeconds: 300, upperBoundSeconds: 1800 };
    } else if (duration <= 300) {
        bounds = { lowerBoundSeconds: 1800, upperBoundSeconds: 3600 };
    } else if (duration <= 300) {
        bounds = { lowerBoundSeconds: 3600, upperBoundSeconds: 86400 };
    } else if (duration > 300) {
        bounds = { lowerBoundSeconds: 86400, upperBoundSeconds: null };
    } else {
        // handle null duration
        bounds = { lowerBoundSeconds: null, upperBoundSeconds: null };
    }

    return `${bounds.lowerBoundSeconds} - ${bounds.upperBoundSeconds}`;
}
